import React from 'react';
import ReactDOM from 'react-dom/client';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { HashRouter } from 'react-router-dom';
import { Capacitor } from '@capacitor/core';
import App from './App';
import theme from './theme';
import './i18n/config';
import './styles/main.css';
import { initSentry } from './services/SentryService';
import analyticsService from './services/AnalyticsService';
import firebaseMessagingService from './services/FirebaseMessagingService';

initSentry();
analyticsService.initialize();
firebaseMessagingService.initialize();

const startApp = () => {
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <React.StrictMode>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <HashRouter>
          <App />
        </HashRouter>
      </ThemeProvider>
    </React.StrictMode>
  );
};

// Capacitor necesita esperar al DOMContentLoaded en native
if (Capacitor.isNativePlatform()) {
  document.addEventListener('DOMContentLoaded', startApp);
} else {
  startApp();
}
